/**
 * True when the user is on an active inspection details or module screen.
 * Excludes list, start, and factory verification routes.
 */
export function isInspectionInProgress(pathname: string): boolean {
  const segments = pathname.split('/').filter(Boolean);
  if (segments[0] !== 'inspections' || segments.length < 2) {
    return false;
  }
  if (segments.length === 2) {
    return segments[1] !== 'start';
  }
  const subRoute = segments[2];
  if (subRoute === 'start' || subRoute === 'verification') {
    return false;
  }
  return true;
}
